import Vue from 'vue'
import VueRouter from 'vue-router'
import ROUTE_DASHBOARD from '@apps/dashboard/router'
import ROUTE_COMPANIES from '@apps/companies/router'
import ROUTE_PLANS from '@apps/plans/router'
// import ROUTE_FINANCIERS from '@apps/financiers/router'
import ROUTE_FINACIAL from '@apps/financial/router'
import ROUTE_FRANCHISEES from '@apps/franchisees/router'
import ROUTE_INVOICING from '@apps/invoicing/router'
import ROUTE_MANUALS from '@apps/manuals/router'
import ROUTE_SERVICES from '@apps/services/router'
import ROUTE_NOT_AUTHORIZED from '@core/router/notAuthorized'
import ROUTE_BEFORE_EACH from '@core/router/beforeEach'
import ROUTE_NOT_AUTHENTICATED from './notAuthenticated'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "CasesRoute" */'@core/layout/Authenticated.vue'),
    // beforeEnter: RequireAutorization,
    children: [
      ROUTE_DASHBOARD,
      ROUTE_COMPANIES,
      ROUTE_PLANS,
      ROUTE_FINACIAL,
      // ROUTE_FINANCIERS,
      ROUTE_FRANCHISEES,
      ROUTE_INVOICING,
      ROUTE_MANUALS,
      ROUTE_SERVICES,
      ROUTE_NOT_AUTHORIZED,
    ],
  },
  ...ROUTE_NOT_AUTHENTICATED,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(ROUTE_BEFORE_EACH)

export default router
